import React, { useEffect } from 'react'
import {
  Container,
  AppBar,
  Toolbar,
  createStyles,
  withStyles,
} from '@material-ui/core'

import Logo from './Logo'
import ModalMenu from './ModalMenu'
import Links from './Links'
import { expandNavBreakpoint } from '../styles'

const styles = (theme) => {
  // const backgroundColor = 'transparent'
  return createStyles({
    appBar: {
      // backgroundColor,
      boxShadow: 'none',
      padding: '1rem 0',
    },
    toolbar: {
      // backgroundColor,
    },
    container: {
      padding: 0,
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    active: {
      boxShadow: '0 0.25rem 0.5rem rgba(97, 79, 0, 0.08)',
      backgroundColor: 'white',
    },
    links: {
      display: 'none',
      [theme.breakpoints.up(expandNavBreakpoint)]: {
        display: 'block',
      },
    },
  })
}

const Nav = ({ classes }) => {
  const id = 'nav'

  const getNav = () => {
    return document.getElementById(id)
  }

  const addActiveClass = (nav) => {
    nav.classList.add(classes.active)
  }

  const removeActiveClass = (nav) => {
    nav.classList.remove(classes.active)
  }

  const getTopDistance = (element) =>
    element.getBoundingClientRect().top + window.scrollY

  const getIfNavIsAfterHeader = (nav) => {
    const header = document.querySelector('section')
    if (header) {
      return getTopDistance(nav) > getTopDistance(header)
    }
    return false
  }

  const handleScroll = () => {
    const nav = getNav()
    if (!nav) return null
    const navIsAfterHeader = getIfNavIsAfterHeader(nav)
    if (navIsAfterHeader) {
      return addActiveClass(nav)
    }
    return removeActiveClass(nav)
  }

  const watchNav = () => {
    document.addEventListener('scroll', handleScroll)
  }

  useEffect(watchNav, [])

  return (
    <AppBar
      className={classes.appBar}
      position="sticky"
      id={id}
      color="primary"
    >
      <Toolbar className={classes.toolbar}>
        <Container className={classes.container} maxWidth="xl">
          <div className={classes.content}>
            <Logo />
            <ModalMenu />
            <div className={classes.links}>
              <Links />
            </div>
          </div>
        </Container>
      </Toolbar>
    </AppBar>
  )
}

export default withStyles(styles)(Nav)
